import { useTheme } from "@mui/material";
import { Users } from "lucide-react";
import type { FC } from "react";
import type { ClientPortfolioDetailCoDebtorResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailCard } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailCard";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { joinTruthy } from "web_myplann/Shared/Utils/textFormatters";

const PageResources = Resources.PortfolioDetail;

type Props = {
	coDebtors: ClientPortfolioDetailCoDebtorResponseDTO[];
};

export const CoDebtorsList: FC<Props> = ({ coDebtors }) => {
	const { t } = useResource();
	const theme = useTheme();

	if (coDebtors.length === 0) {
		return null;
	}

	return (
		<DetailCard label={t(PageResources.Loan.coDebtors)}>
			{coDebtors.map((coDebtor, index) => (
				<ListRow
					key={coDebtor.id}
					title={joinTruthy([coDebtor.firstname, coDebtor.lastname], " ")}
					subtitle={coDebtor.identification}
					tabularSubtitle
					icon={
						<Users size={theme.iconSize.md} color={theme.palette.blue.main} />
					}
					iconBg={theme.palette.blue[100]}
					isLast={index === coDebtors.length - 1}
				/>
			))}
		</DetailCard>
	);
};
